import { Component, OnInit } from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router';
import {AuthService} from '../core/services/auth.service';
import {DeleteDeactivateModalComponent} from '../modals/delete-deactivate-modal/delete-deactivate-modal.component';
import {AlertService} from '../core/services/alert.service';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {

  public loadingSubs = false;
  public subAdmins = new MatTableDataSource();
  public filteredSubAdmins = new MatTableDataSource();

  constructor(public snack: MatSnackBar, public router: Router, public dialog: MatDialog,
              public auth: AuthService, public alert: AlertService) { }

  ngOnInit(): void {
    this.loadSubs();
  }

  private loadSubs() {
    this.loadingSubs = true;
    this.auth.getSubs('00000000').subscribe(res => {
      this.loadingSubs = false;
      this.subAdmins.data = res as [];
      this.filteredSubAdmins.data = res as [];
    }, err => {
      this.loadingSubs = false;
      this.snack.open('Fehler beim Zugriff auf die Mitarbeiter.', '', {panelClass: 'danger-snackbar'});
      if(err.status == 403)
        this.router.navigateByUrl('/');
    })
  }

  addSubAdmin() {
    let sub = {
      edit: true,
      kundenkennung: null,
      kundennummer: '00000000',
      vorname: '',
      nachname: '',
      email: '',
      saving: false
    };
    this.subAdmins.data = [...this.subAdmins.data, sub];
    this.filteredSubAdmins.data = [...this.filteredSubAdmins.data, sub];
  }

  saveSubAdmin(subData) {
    subData.saving = true;
    this.auth.addSub(subData).subscribe(res => {
      subData.saving = false;
      subData.kundenkennung = res['kundenkennung'];
      subData.edit = false;
      this.snack.open('Mitarbeiter erfolgreich hinzugefügt.', '', {panelClass: 'success-snackbar'});
    }, err => {
      subData.saving = false;
      this.alert.showValidationError(err);
      this.alert.showCustomValidationError(err);
    })
  }

  deleteSubAdmin(subData) {
    this.dialog.open(DeleteDeactivateModalComponent, {
      data: {
        name: subData.kundenkennung,
        object: subData,
      }
    }).afterClosed().subscribe(res => {
      if(!res) {
        return;
      }
      subData.saving = true;
      this.auth.deleteSub(subData.kundenkennung).subscribe(res => {
        subData.saving = false;
        this.loadSubs();
      }, err => {
        this.snack.open('Fehler beim Löschen des Mitarbeiters.', '', {panelClass: 'danger-snackbar'});
        subData.saving = false;
      })
    });
  }
}
